import { render } from "./Link.vue?vue&type=template&id=0ba141e0&bindings={\"icon\":\"props\",\"route\":\"props\",\"routeName\":\"props\",\"label\":\"props\",\"action\":\"props\",\"activeClass\":\"data\",\"inactiveClass\":\"data\"}"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
script.render = render

export default script